import { defineComponent as _defineComponent } from 'vue'
import { computed, useAttrs } from 'vue';
import kebabCase from 'lodash/kebabCase';
import mapKeys from 'lodash/mapKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataRow',
  props: {
    label: { default: '' },
    labelClass: null
  },
  setup(__props: any) {

const attrs = useAttrs();



const labelVColAttrs = computed(() => {
  return {
    cols: 4,
    ...mapKeys(attrs, (v, k) => kebabCase(k)),
  } as any;
});

const valueVColAttrs = computed(() => {
  const attrs: any = {};
  ['cols', 'sm', 'md', 'lg', 'xl'].forEach((key) => {
    if (typeof labelVColAttrs.value[key] === 'number' || typeof labelVColAttrs.value[key] === 'string') {
      attrs[key] = 12 - Number(labelVColAttrs.value[key]);
    }
  });
  return attrs;
});

return { __sfc: true,attrs, labelVColAttrs, valueVColAttrs }
}

})